import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/upgradedUrl';
import template from '@bingads-webui-campaign-legacy/crud-ad/template/adsEditor/upgradedUrl.pug';
import UpgradedUrl from '@bingads-webui-component-legacy/upgraded-url/view/index';

export default class View extends Backbone.View {
  initialize({
    placeholders = {},
    adViewModel,
    showOnlyFinalUrl = false,
    api = null,
    editMode = false,
    urlOptionsEnabled = false,
    defaultLandingPageUrl = '',
    placeholderEnabled = true,
    ariaPrefix = '',
  } = {}) {
    this.adViewModel = adViewModel;
    this.placeholders = placeholders;
    this.showOnlyFinalUrl = showOnlyFinalUrl;
    this.api = api;
    this.editMode = editMode;
    this.urlOptionsEnabled = urlOptionsEnabled;
    this.defaultLandingPageUrl = defaultLandingPageUrl;
    this.placeholderEnabled = placeholderEnabled;
    this.ariaPrefix = ariaPrefix;

    this.viewModel = new ViewModel();
  }

  render() {
    this.$el.empty().append(template({}));
    ko.applyBindings(this.viewModel, this.el);

    let defaultOptions = {
      urlOptionsEnabled: this.urlOptionsEnabled,
      isMobilePreferred: _.isFunction(this.adViewModel.DevicePreference) ? this.adViewModel.DevicePreference.isMobile() : false,
      entityType: 'Ad',
      placeholderEnabled: this.placeholderEnabled,
      placeholders: this.placeholders,
      showOnlyFinalUrl: this.showOnlyFinalUrl,
      landingPageUrlRequired: true,
      highLightModeInError: true,
    };

    if (_.isObject(this.model)) {
      let isFinalUrl = _.isArray(this.model.FinalUrls) && !_.isEmpty(this.model.FinalUrls),
        url = isFinalUrl ? this.model.FinalUrls[0] : this.model.DestinationUrl,
        mobileUrl = _.isArray(this.model.MobileFinalUrls) && !_.isEmpty(this.model.MobileFinalUrls) ? this.model.MobileFinalUrls[0] : undefined;

      this.upgradedUrlView = new UpgradedUrl(_.extend(defaultOptions, {
        url,
        isFinal: isFinalUrl,
        finalMobileUrl: mobileUrl,
        trackingTemplate: _.result(this.model, 'TrackingUrlTemplate'),
        customParameters: _.isEmpty(this.model.UrlCustomParameters) ? undefined : _.clone(this.model.UrlCustomParameters), // eslint-disable-line
        editMode: true,
        ariaPrefix: this.ariaPrefix,
      }));

      this.adViewModel.isFinal(isFinalUrl);
      this.adViewModel.url(url);
      this.adViewModel.mobileUrl(mobileUrl);
    } else {
      this.upgradedUrlView = new UpgradedUrl(_.defaults(defaultOptions, {
        url: this.defaultLandingPageUrl,
        ariaPrefix: this.ariaPrefix,
      }));
    }

    this.$('.upgraded-url__container').empty().append(this.upgradedUrlView.render().el);
    this.upgradedUrlView.on('finalUrlChanged', this.urlInputChanged, this);
    this.upgradedUrlView.on('mobileUrlChanged', this.mobileUrlChanged, this);
    this.upgradedUrlView.on('finalUrlSelected', () => {
      this.adViewModel.isFinal(true);
    });
    this.upgradedUrlView.on('destinationUrlSelected', () => {
      this.adViewModel.isFinal(false);
    });

    return this;
  }

  validate() {
    return this.upgradedUrlView.isValid();
  }

  urlInputChanged() {
    let url = this.upgradedUrlView.getValues().finalUrl.url;

    this.adViewModel.url(url);
  }

  mobileUrlChanged() {
    let url = this.upgradedUrlView.getValues().mobileUrl;

    this.adViewModel.mobileUrl(url);
  }

  devicePreferenceChanged(event) {
    this.upgradedUrlView.devicePreferenceChanged(event);
  }

  toObject() {
    let arrayEmptyValue = this.api === 'odata' ? [] : null;
    let stringEmptyValue = this.api === 'odata' ? '' : null;

    let uulModel = this.upgradedUrlView.toObject();

    if (this.editMode) {
      if (!this.adViewModel.isFinal() && !_.isEmpty(this.model.FinalUrls)) {
        // if update to use destinationUrl, then reset final url fields
        uulModel.FinalUrls = arrayEmptyValue;
        uulModel.MobileFinalUrls = arrayEmptyValue;
        uulModel.TrackingUrlTemplate = stringEmptyValue;
        uulModel.UrlCustomParameters = arrayEmptyValue;
      } else if (this.adViewModel.isFinal() && !_.isEmpty(this.model.DestinationUrl)) {
        //if update to use final url, then reset destination url field
        uulModel.DestinationUrl = stringEmptyValue;
      } else if (!this.adViewModel.isFinal()) {
        // if still destinationUrl
        if (_.isEmpty(uulModel.DestinationUrl)) {
          uulModel.DestinationUrl = stringEmptyValue;
        }
      } else if (this.adViewModel.isFinal()) {
        // if still finalUrl
        if (_.isEmpty(uulModel.FinalUrls)) {
          uulModel.FinalUrls = arrayEmptyValue;
        }
        if (_.isEmpty(uulModel.MobileFinalUrls)) {
          uulModel.MobileFinalUrls = arrayEmptyValue;
        }
        if (_.isEmpty(uulModel.TrackingUrlTemplate)) {
          uulModel.TrackingUrlTemplate = stringEmptyValue;
        }
        if (_.isEmpty(uulModel.UrlCustomParameters)) {
          uulModel.UrlCustomParameters = arrayEmptyValue;
        }
      }
    }

    return uulModel;
  }

  handleApiErrors() {
    let errorObject = _.object(this.viewModel.upgradedUrlFields, _.map(this.viewModel.upgradedUrlFields, (key) => {
      return _.isFunction(this.adViewModel[key].errors) ? this.adViewModel[key].errors() : [];
    }));

    this.upgradedUrlView.handleApiErrors(errorObject);
  }

  clearApiErrors() {
    this.upgradedUrlView.clearApiErrors();
  }
}
